import React, { useMemo, useState } from "react";
import {
  Card,
  Input,
  Select,
  Space,
  Tag,
  Typography,
  Row,
  Col,
  Form,
  Empty,
  List,
} from "antd";
import {
  ArchiveRestore,
  History,
  SearchIcon,
  Upload as UploadIcon,
} from "lucide-react";
import DrawerApp from "components/drawer-app";
import { ESTADOS, FAIXAS } from "views/util/filter";
import CompanyDetailBody from "./painel-company-detail";

const { Text, Title } = Typography;

export default function CompaniesHistoryPanel({ data, setEmpresas }) {
  const empresas = useMemo(() => {
    return data;
  }, [data]);
  const [estadoFiltro, setEstadoFiltro] = useState();
  const [faixaFiltro, setFaixaFiltro] = useState();
  const [searchTerm, setSearchTerm] = useState("");

  const [sel, setSel] = useState(null);
  const [openDetailItem, setOpenDetailItem] = useState(false);
  const onCloseDetailItem = () => {
    setOpenDetailItem(false);
    setSel(null);
  };

  const empresasFiltradas = useMemo(() => {
    return empresas.filter((e) => {
      const m1 = !estadoFiltro || e.state === estadoFiltro;
      const m2 = !faixaFiltro || e.billing === faixaFiltro;
      const m3 =
        !searchTerm ||
        e.name?.toLowerCase()?.includes(searchTerm) ||
        e.document?.toLowerCase()?.includes(searchTerm);
      return m1 && m2 && m3;
    });
  }, [empresas, estadoFiltro, faixaFiltro, searchTerm]);

  return (
    <>
      <Card
        title={
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Space>
              <ArchiveRestore size={18} style={{ marginTop: 4 }} />
              <Text>Histórico das Empresas ({empresasFiltradas.length})</Text>
            </Space>

            <div
              style={{
                fontSize: 12,
                color: "rgba(0, 0, 0, 0.45)",
                fontWeight: 50,
              }}
            >
              Esse painel contém {empresasFiltradas.length} empresas
            </div>
          </div>
        }
        style={{
          backgroundColor: "#F59C27",
          display: "flex",
          flexDirection: "column",
          minWidth: 400,
          minHeight: 300,
          maxHeight: "85vh",
        }}
        bodyStyle={{
          padding: 12,
          display: "flex",
          flexDirection: "column",
          gap: 8,
          flex: 1,
          overflow: "hidden",
        }}
      >
        <Space.Compact style={{ width: "96%" }}>
          <Input
            allowClear
            className="input-form"
            placeholder="Buscar por nome ou CNPJ"
            prefix={<SearchIcon size={14} />}
            onChange={(e) => setSearchTerm(e.target.value?.toLowerCase() || "")}
            style={{ height: "40px" }}
            autoComplete={false}
          />
        </Space.Compact>
        <Space.Compact style={{ width: "100%", marginBottom: 20 }}>
          <Select
            allowClear
            style={{ minWidth: 160 }}
            className="h40-select"
            placeholder="Estado"
            options={ESTADOS.map((e) => ({ value: e, label: e }))}
            onChange={setEstadoFiltro}
            value={estadoFiltro}
          />
          <Select
            allowClear
            style={{ minWidth: 200 }}
            className="h40-select"
            placeholder="Faixa de faturamento"
            options={FAIXAS.map((f) => ({ value: f, label: f }))}
            onChange={setFaixaFiltro}
            value={faixaFiltro}
          />
        </Space.Compact>

        <div
          className="custom-scroll"
          style={{ flex: 1, overflow: "auto", paddingRight: 20 }}
        >
          <List
            dataSource={empresasFiltradas}
            locale={{ emptyText: <Empty description="Nenhuma empresa" /> }}
            renderItem={(r) => (
              <List.Item style={{ padding: 0, border: "none" }}>
                <button
                  onClick={() => {
                    setSel(r);
                    setOpenDetailItem(true);
                  }}
                  style={{
                    width: "100%",
                    textAlign: "left",
                    background: "#fff",
                    border: "1px solid #f0f0f0",
                    borderRadius: 10,
                    padding: "10px 12px",
                    marginBottom: 8,
                    cursor: "pointer",
                    boxShadow:
                      "0 1px 1px rgba(0,0,0,0.08), 0 3px 2px rgba(0,0,0,0.18)",
                  }}
                >
                  <Title level={5} style={{ margin: 0 }}>
                    {r.name}
                  </Title>
                  <div style={{ marginTop: 4 }}>
                    <Text type="secondary">CNPJ: </Text>
                    <Text>{r.document}</Text>
                  </div>
                  <div style={{ marginTop: 6 }}>
                    <Space wrap>
                      <Tag color="geekblue">{r.state}</Tag>
                      <Tag color="green">{r.billing}</Tag>
                    </Space>
                  </div>
                </button>
              </List.Item>
            )}
          />
        </div>
      </Card>

      <DrawerApp
        open={openDetailItem}
        onClose={onCloseDetailItem}
        title={sel ? sel.name : "Detalhes"}
        body={
          sel ? (
            <CompanyDetailBody
              empresaSel={sel}
              setEmpresaSel={setSel}
              setEmpresas={setEmpresas}
              ESTADOS={ESTADOS}
              FAIXAS={FAIXAS}
              isView={true}
              typeView={"HISTORY"}
            />
          ) : null
        }
        size="large"
        isOnlyView={true}
        width={outerWidth < 750 ? "100%" : "50%"}
      />
    </>
  );
}
